<template>
  <section id="noCommodities">
    <Empty
      class="custom-image"
      :image="require('@/assets/cart/gouwuchekong.svg')"
      description="你的购物车空空的～"
    />
    <Button
      round
      type="danger"
      size="small"
      class="link_to_home"
      style="padding-left: 16px; padding-right: 16px"
      @click="$router.push('/')"
      >去逛逛</Button
    >
  </section>
</template>
<script>
import { Empty, Button } from "vant";
export default {
  components: { Empty, Button },
};
</script>
<style lang="less" slot-scope>
</style>
